
export class StatusChangeRequest  { 
    public service_number?: number;
    public comments?: string;
    public lat?: number;
    public lng?: number;
    public images?: Array<string>;
    public driver_id?: number;
    public version?: string;
    public platform?: string;

}

export class NoShowData  { 
    public comments?: string;
    public lat?: number;
    public lng?: number;
    public images?: Array<string>;

}